/*
 |--------------------------------------------------------------------------
 | Translations
 |--------------------------------------------------------------------------
 */

let __ = function (key) {
  return window.Laravel.translations[key] || key;
};

// Translate a parameter
let __parameter = function (param) {

  param = _.toString(param);
  
  let labels = param.split(".");
  if (labels.length != 2) {
    return param;
  }
  let label = __(labels[0]) + " - ";
  
  let parts = labels[1].split(Laravel.erp.rule_id_delimiter);
  label += __(parts[0]);
  
  if (parts.length == 2) {
    label += " (" + parts[1] + ")";
  }
  
  return label;
}; 

export { __, __parameter };
